import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <div className={"footer"}>
        Created with ❤️ &nbsp;by
        <span className={"footer_link"}>
          <a href="https://www.screenthinker.com">Screenthinker</a>
        </span>
        <span className={"footer_link footer_link--nodecoration"}>and</span>
        <span className={"footer_link"}>
          <a href="https://jjdv.xyz">JJDV</a>
        </span>
      </div>
    );
  }
}

export default Footer;
